import {Component} from '@angular/core';
import {ElciaButton} from '../components/buttons/button/button';

@Component({
  selector: 'elcia-doc-components',
  imports: [
    ElciaButton
  ],
  templateUrl: './doc-components.html',
  styleUrl: './doc-components.scss'
})
export class DocComponents {

}
